var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Observable, forkJoin } from 'rxjs';
import { ThumbnailConstants } from '../shared/thumbnail.constants';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { StoryType } from '../story/models/story-type.enum';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
// #FIXME: Thumbnail service does not work for copying module to module thumbnails, which is the 
// whole point of this service.
var thumbnailServiceBaseURL = '/ws/thumbs';
var thumbnailServiceCopyURL = '/ws/thumbs/copy';
var thumbnailServiceOptions = {
    headers: new HttpHeaders().set('Content-Type', 'application/json'),
    responseType: 'text'
};
var ModulesThumbnailService = /** @class */ (function () {
    function ModulesThumbnailService(http) {
        this.http = http;
    }
    ModulesThumbnailService.prototype.saveStoryThumbnails = function (_a) {
        /* Thumbnail Data
        The thumbnails are specific to the currently loaded content.
        Changes made to the thumbnais may or may not be replacements for the currently loaded content.
        When current thumbnails are meant to be "saved-as", we need to have a map of the target ids to the current ids.
        */
        var _this = this;
        var storyId = _a.storyId, storyType = _a.storyType, thumbnails = _a.thumbnails, chapterIdMap = _a.chapterIdMap, indexId = _a.indexId, _b = _a.deleteUnused, deleteUnused = _b === void 0 ? false : _b;
        // post/copy thumbnails for all story chapters and story
        var thumbnailRequests$ = [];
        var usedSourceIds = {};
        Object.entries(chapterIdMap)
            .forEach(function (_a) {
            var _b = __read(_a, 2), chapterId = _b[0], thumbId = _b[1];
            var sourceThumbnail = thumbnails.get(thumbId); // the thumbnail object
            usedSourceIds[thumbId] = true; // track as part of thumbnail cleanup
            var targetPath = _this.createThumbnailPath(storyType, storyId, chapterId);
            if (sourceThumbnail && sourceThumbnail.snapshot) {
                thumbnailRequests$.push(_this.postThumbnail(sourceThumbnail.snapshot, targetPath));
                if (chapterId === indexId) {
                    var indexPath = _this.createThumbnailPath(storyType, storyId);
                    thumbnailRequests$.push(_this.postThumbnail(sourceThumbnail.snapshot, indexPath));
                }
            }
            else {
                // add copy request for existing story, chapterthumbnail
                var sourcePath = sourceThumbnail.urls.large.split('/thumbs/')[1];
                thumbnailRequests$.push(_this.copyThumbnail(sourcePath, targetPath));
                if (chapterId === indexId) {
                    var indexPath = _this.createThumbnailPath(storyType, storyId);
                    thumbnailRequests$.push(_this.copyThumbnail(sourcePath, indexPath));
                }
            }
        });
        // delete any unused thumnbnails on the server (when we are replacing an existing story's thumbnails)
        if (deleteUnused) {
            Object.keys(thumbnails)
                .filter(function (sourceChapterId) { return !(sourceChapterId in usedSourceIds); })
                .forEach(function (sourceChapterId) {
                var deletePath = thumbnails.get(sourceChapterId).urls.large.split('/thumbs/')[1];
                thumbnailRequests$.push(_this.deleteThumbnail(deletePath));
            });
        }
        return forkJoin(thumbnailRequests$);
    };
    // create the thumbnail location (relative to content)
    ModulesThumbnailService.prototype.createThumbnailPath = function (storyType, storyId, chapterId) {
        // storyId: preview/test.json
        // Sanitize story ID
        storyId = storyId.replace('.json', '');
        // storyId: preview/test
        // Determine which thumbnail service to use
        var thumbType = (storyType === StoryType.Bookmark) ? 'bookmarks' : 'modules';
        var imageName = storyId + "/large";
        // imageName: preview/test/large
        if (!!chapterId) {
            imageName = imageName + "/chapters/" + chapterId + ".jpg";
            // imageName: preview/test/large/chapter-9472aead-8be3-43b9-9ae8-6821b4cfcccd.jpg
        }
        else {
            imageName = imageName + "/index.jpg";
        }
        return [thumbType, imageName].join('/');
    };
    // request to server to save a thumbnail
    ModulesThumbnailService.prototype.postThumbnail = function (sourceURL, targetPath) {
        var _this = this;
        var size = new ThumbnailConstants().thumbnails.sizes.large;
        var image = new Image();
        var canvas = document.createElement('canvas');
        canvas.width = size[0];
        canvas.height = size[1];
        var context = canvas.getContext('2d');
        image.src = sourceURL;
        return new Observable(function (observer) {
            image.onload = function () {
                // transfer image to canvas
                context.drawImage(image, 0, 0);
                // convert to data url
                var dataURL = canvas.toDataURL('image/jpeg', 1.0);
                // issue post
                var dstURL = [thumbnailServiceBaseURL, targetPath].join('/');
                _this.http.post(dstURL, { image: dataURL }, thumbnailServiceOptions).subscribe(function () {
                    observer.complete();
                });
            };
        });
    };
    // request to delete thumbnail from server
    ModulesThumbnailService.prototype.deleteThumbnail = function (targetPath) {
        var dstURL = [thumbnailServiceBaseURL, targetPath].join('/');
        return new Observable(function (observer) {
            var request = new Request(dstURL, { method: 'DELETE' });
            fetch(request).then(function (response) {
                observer.complete();
            });
        });
    };
    // request to server to copy a thumbnail from one location to another
    ModulesThumbnailService.prototype.copyThumbnail = function (sourcePath, targetPath) {
        return this.http.post(thumbnailServiceCopyURL, { src: sourcePath, dst: targetPath }, thumbnailServiceOptions);
    };
    ModulesThumbnailService.ngInjectableDef = i0.defineInjectable({ factory: function ModulesThumbnailService_Factory() { return new ModulesThumbnailService(i0.inject(i1.HttpClient)); }, token: ModulesThumbnailService, providedIn: "root" });
    return ModulesThumbnailService;
}());
export { ModulesThumbnailService };
